import { render } from "./addCarouselModule.vue?vue&type=template&id=285000f0&scoped=true"
import script from "./addCarouselModule.vue?vue&type=script&lang=js"
export * from "./addCarouselModule.vue?vue&type=script&lang=js"

import "./addCarouselModule.vue?vue&type=style&index=0&id=285000f0&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285000f0"]])

export default __exports__